import { get } from 'lodash';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing, withHandlers } from 'recompose';

import AddProducts from '../components/AddProducts';
import withToggle from '../../../../common/hoc/withToggle';
import { setActiveBarber } from '../../../../register/sale/actions';
import { setCustomer } from '../../../../register/customer/actions';
import { setSaleSource, resetSaleSource } from '../../../../register/source/actions';
import withPermissions from '../../../../auth/utils/withPermissions';
import { canUserViewRegister } from '../../../../common/helpers/users';
import withValidateSale from '../../../../register/hoc/withValidateSale';

const withCheckPermissions = compose(
  withPermissions,
  branch(
    props => !canUserViewRegister(props.permissions),
    renderNothing,
  ),
);

export default compose(
  withCheckPermissions,
  connect(
    null,
    { setActiveBarber, setCustomer, setSaleSource, resetSaleSource }
  ),
  withValidateSale,
  withToggle('modal'),
  withHandlers({
    onClick: props => () => {
      props.setSaleSource('appointment_product');
      // use card from appointment payment to pay for products instead of using the default one
      props.setCustomer(props.appointment.customer, get(props.appointment.payment, 'paymentCardId'));
      props.setActiveBarber(props.appointment.barberId);
      props.modalOn();
    },
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.resetSaleSource();
    },
  }),
)(AddProducts);
